// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f5d403d87da26259c388","655":"7f346a644ba1ba537d4a"}[chunkId] + ".js";
};